// @ts-nocheck
import { Popconfirm, Switch } from "antd";
import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import BadgeForTable from "components/shared-components/BadgeForTable";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import {
  useActiveCustomer,
  useActiveIsNotedCustomer,
  useDeleteCustomer,
  useListCustomer,
} from "hooks";
import React, { useEffect, useRef, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Button, Card, CardBody, Col, Input, Row } from "reactstrap";
import { setListCustomerColumn } from "store/actions";
import AddCodeUseModal from "./CodeUse/AddCodeUseModal";
import CodeUseModal from "./CodeUse/CodeUseModal";
import DetailCustomer from "./DetailCustomer";
import SaleSupport from "./Sale/SaleSupport";
import {
  CUSTOMER_SOURCE,
  customerModeList,
  customerRecordStatus,
  customerRecordStatusMode,
  getInitCustomerParams,
} from "./utils";

const ListCustomer = props => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["customer"]);
  const { addToast } = useToasts();

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);

  // Detail Customer Modal
  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);

  // Delete Customer Modal
  const [dataDeleteCustomer, setDataDeleteCustomer] = useState({
    customerId: null,
  });
  const [deleteCustomerModal, setDeleteCustomerModal] = useState(false);

  // Active Customer Modal
  const [dataActiveCustomer, setDataActiveCustomer] = useState({
    customerId: null,
  });
  const [activeCustomerModal, setActiveCustomerModal] = useState(false);
  const [customerChoosen, setCustomerChoosen] = useState(undefined);
  const [isViewSale, setIsViewSale] = useState(false);

  const {
    list: { columnsVisible: customerColumnsVisible },
  } = useSelector(state => state.customer);

  // List Customer
  const [customerParams, setCustomerParams] = useState(getInitCustomerParams);
  const {
    isLoading,
    data: customerList,
    refetch: listCustomer,
  } = useListCustomer({ params: customerParams });

  const debounceTimeout = useRef(null);

  const [searchQuantity, setSearchQuantity] = useState("");
  const handleInputChange = e => {
    const value = e.target.value;

    // Xóa timer cũ nếu có
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    if (!value || value < 1) {
      setCustomerParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          // total_qty,unworn_qty
          "filter[unworn_qty][lte]": undefined,
          "filter[total_qty][gt]": undefined,
        },
      }));
      return;
    }
    // Tạo timer mới với độ trễ 500ms
    debounceTimeout.current = setTimeout(() => {
      setCustomerParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          // total_qty,unworn_qty
          "filter[unworn_qty][lte]": value,
          "filter[total_qty][gt]": 0,
        },
      }));
    }, 500);
  };

  // Active Customer
  const handleActiveCustomer = () => {
    listCustomer();
  };
  const { mutate: activeCustomer } = useActiveCustomer(
    handleActiveCustomer,
    handleActiveCustomer
  );
  const { mutate: activeIsNotedCustomer } = useActiveIsNotedCustomer(
    handleActiveCustomer,
    handleActiveCustomer
  );

  // Delete Customer
  const handleDeleteCustomer = () => {
    listCustomer();
  };
  const { mutate: deleteCustomer } = useDeleteCustomer(
    handleDeleteCustomer,
    handleDeleteCustomer
  );

  useEffect(() => {
    if (customerParams && customerParams.run) {
      listCustomer();
    }
  }, [customerParams]);

  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    setCustomerParams(prev => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
      run: true,
    }));

    initColumn();
  }, [t]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (customerList) {
      initColumn();
    }
  }, [customerList]);

  const initColumn = () => {
    if (
      customerColumnsVisible &&
      Object.keys(customerColumnsVisible).length > 0
    ) {
      initColumns.forEach(item => {
        if (customerColumnsVisible[item.dataField] !== undefined) {
          item.hidden = !customerColumnsVisible[item.dataField];
        }
      });
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    dispatch(setListCustomerColumn(field, value));
    initColumn();
  };

  const selectOptionsTable = (cell = undefined, name = "", prefix = "") => {
    let options = [];
    const select = {};
    switch (name) {
      case "record_status":
        if (prefix === "customer") {
          options = customerRecordStatus;
        }
        break;
      default:
        if (cell) {
          return "";
        } else {
          return select;
        }
    }

    // Set option to select with Array values defined
    options.forEach(item => {
      select[item.key] = t(`table.${name}.${prefix}.${item.key}`);
    });

    // Use For Column Formatter
    if (cell) {
      return select[cell];
    }

    return { ...select };
  };

  const formatOptionsTable = (cell, name = "", prefix = "") => {
    let options = [];
    switch (name) {
      case "record_status":
        if (prefix === "customer") {
          options = customerRecordStatus;
        }
        break;
      default:
        return "";
    }

    return options.map(
      item =>
        item.key === cell && (
          <BadgeForTable
            key={item.key}
            badgeColor={item.badgeColor ? item.badgeColor : ""}
          >
            {selectOptionsTable(cell, name, prefix)}
          </BadgeForTable>
        )
    );
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    setCustomerParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : customerParams.sort,
      columnFilter:
        {
          ...prev.columnFilter,
          ...columnFilter,
        } || {},
      page: page || 1,
      sizePerPage: sizePerPage || 10,
    }));
  };

  const onSearchAllHandle = value => {
    setCustomerParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const checkIsValidSource = data => {
    return data.source && data.source === CUSTOMER_SOURCE.DEFAULT;
  };

  const toggleDeleteCustomerModal = () => {
    setDeleteCustomerModal(!deleteCustomerModal);
  };
  const clickDeleteCustomerHandler = (row, index) => {
    const isValidSource = checkIsValidSource(row);

    if (isValidSource) {
      setDataDeleteCustomer({ customerId: row.id });
      toggleDeleteCustomerModal();
    } else {
      addToast(
        `Không thể thực hiện vì không phải khách hàng được tạo từ GLOG`,
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    }
  };
  const deleteSingleCustomerHandler = () => {
    deleteCustomer({
      customerId: dataDeleteCustomer.customerId,
    });
    toggleDeleteCustomerModal();
  };

  const toggleActiveCustomerModal = () => {
    setActiveCustomerModal(!activeCustomerModal);
  };
  const clickActiveCustomerHandler = (row, index) => {
    const isValidSource = checkIsValidSource(row);

    if (isValidSource) {
      setDataActiveCustomer({ customerId: row.id });
      toggleActiveCustomerModal();
    } else {
      addToast(
        `Không thể thực hiện vì không phải khách hàng được tạo từ GLOG`,
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    }
  };
  const activeSingleCustomerHandler = () => {
    activeCustomer({
      customerId: dataActiveCustomer.customerId,
      data: {
        record_status: "O",
      },
    });
    toggleActiveCustomerModal();
  };

  const activeIsNotedCustomerHandler = customer => {
    activeIsNotedCustomer({
      customerId: customer.id,
      data: {
        is_noted: customer.is_noted === 1 ? 0 : 1,
      },
    });
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
    switch (modeSet) {
      case customerModeList.EDIT_CUSTOMER_DETAIL:
        listCustomer();
        break;
      default:
        break;
    }
  };

  const clickEditCustomerHandler = (row, index) => {
    setDataDetail({ customerId: row.id });
    setMode(customerModeList.EDIT_CUSTOMER_DETAIL);
    toggleDetailModal();
  };

  const clickAddCodeOfCustomerHandler = (row, index) => {
    setCustomerChoosen(row);
    toggleViewAddCodeUse();
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail({ customerId: row.id });
      setMode(customerModeList.VIEW_CUSTOMER_DETAIL);
      toggleDetailModal();
    },
  };

  const toggleSaleSupport = () => setIsViewSale(prev => !prev);

  const [isViewCodeUse, setIsViewCodeUse] = useState(false);
  const toggleViewCodeUse = () => setIsViewCodeUse(prev => !prev);

  const [isViewAddCodeUse, setIsViewAddCodeUse] = useState(false);
  const toggleViewAddCodeUse = () => setIsViewAddCodeUse(prev => !prev);

  const handleViewSaleSupport = row => {
    setCustomerChoosen(row);
    toggleSaleSupport();
  };

  const handleViewCodeUse = row => {
    setCustomerChoosen(row);
    toggleViewCodeUse();
  };

  const listRowAction = [
    {
      // actionAccess: actionAccess.UPDATE_JOB_TITLE,
      icon: <i className="fas fa-plus fa-lg text-info" />,
      text: "Tạo thêm mã",
      onClick: clickAddCodeOfCustomerHandler,
    },
    {
      // actionAccess: actionAccess.UPDATE_JOB_TITLE,
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: t("table.actions.edit.customer"),
      onClick: clickEditCustomerHandler,
    },
    {
      // actionAccess: actionAccess.ACTIVE_JOB_TITLE,
      icon: <i className="fas fa-lock fa-lg text-danger" />,
      text: t("table.actions.delete.customer"),
      conditionVisible: {
        record_status: [customerRecordStatusMode.ACTIVE],
      },
      onClick: clickDeleteCustomerHandler,
    },
    {
      // actionAccess: actionAccess.ACTIVE_JOB_TITLE,
      icon: <i className="fas fa-lock-open fa-lg text-success" />,
      text: t("table.actions.active.customer"),
      conditionVisible: {
        record_status: [customerRecordStatusMode.INACTIVE],
      },
      onClick: clickActiveCustomerHandler,
    },
  ];

  const listMultipleRowAction = [];

  const initColumns = [
    {
      dataField: "code",
      text: t("table.code"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.code"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "name",
      text: t("table.name"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.name"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "is_noted",
      text: t("table.is_noted"),
      sort: true,
      align: "center",
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.is_noted"),
        }),
        options: {
          0: "Không",
          1: "Có",
        },
      }),
      formatter: (cell, row) => (
        <Popconfirm
          title={`${cell === 1 ? "Tắt" : "Bật"} cần lưu ý ?`}
          onConfirm={() => activeIsNotedCustomerHandler(row)}
          okText="Ok"
          cancelText="Huỷ"
        >
          <Switch size="small" checked={cell === 1} />
        </Popconfirm>
      ),
    },
    {
      dataField: "sale_support",
      text: "Sale phụ trách",
      align: "center",
      formatter: (_cell, row) => (
        <Button
          title="Xem chi tiết"
          color="link"
          onClick={() => handleViewSaleSupport(row)}
        >
          <i className="fas fa-solid fa-list-ul"></i>
        </Button>
      ),
    },
    {
      dataField: "custom_code",
      text: "Mã chưa sử dụng",
      align: "center",
      formatter: (_cell, row) => (
        <div
          className="d-flex align-items-center"
          onClick={() => handleViewCodeUse(row)}
          style={{ cursor: "pointer" }}
        >
          <div className="d-flex gap-1">
            <div className="text-success fw-bold">{row?.unworn_qty}</div>/
            <div className="text-info">{row?.total_qty}</div>
          </div>
          <Button title="Xem chi tiết" color="link">
            <i className="fas fa-solid fa-list-ul"></i>
          </Button>
        </div>
      ),
    },
    // {
    //   dataField: "note",
    //   text: t("table.note"),
    //   filter: textFilter({
    //     delay: DELAY_FILTER_TIME,
    //     placeholder: t("placeholder.enter", {
    //       title: t("table.note"),
    //     }),
    //   }),
    //   sort: true,
    //   allowExport: true,
    // },
    {
      dataField: "record_status",
      text: t("table.record_status.customer.name"),
      sort: true,
      align: "center",
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.record_status.customer.name"),
        }),
        options: selectOptionsTable(undefined, "record_status", "customer"),
      }),
      formatter: (cell, row) => {
        // "some" return boolean
        if (cell && customerRecordStatus.some(item => item.key === cell)) {
          return formatOptionsTable(cell, "record_status", "customer");
        } else {
          return ""; // Set Empty If Value Not Match
        }
      },
      allowExport: true,
    },
    {
      dataField: "maker_date",
      text: t("table.maker_date"),
      sort: true,
      hidden: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={customerParams.columnFilter}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "maker_id",
      text: t("table.maker_id"),
      hidden: true,
      formatter: (cell, row) => {
        return row.maker && row.maker.display_name
          ? row.maker.display_name
          : cell;
      },
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.maker_id"),
        }),
      }),
      allowExport: true,
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={customerParams.columnFilter}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "checker_id",
      text: t("table.checker_id"),
      formatter: (cell, row) => {
        return row.checker && row.checker.display_name
          ? row.checker.display_name
          : cell;
      },
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.checker_id"),
        }),
      }),
      allowExport: true,
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.list") + ` (${customerList?.totalCount || 0})`}
            breadcrumbItems={[
              { name: t("title.manager") },
              { name: t("title.list") },
            ]}
          />

          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              {/* Detail Customer Modal */}
              <DetailCustomer
                handleViewCodeUse={handleViewCodeUse}
                dataDetail={dataDetail}
                isOpenModal={detailModal}
                toggleModal={toggleDetailModal}
                mode={mode}
              />
              {/* Delete Customer Modal */}
              <ConfirmModal
                isOpen={deleteCustomerModal}
                titleHeader={t("form.submit.delete.customer.confirm.header")}
                titleBody={t("form.submit.delete.customer.confirm.body")}
                onConfirm={deleteSingleCustomerHandler}
                textBtnConfirm={t("form.submit.delete.customer.confirm.agree")}
                textBtnCancel={t("form.submit.delete.customer.confirm.cancel")}
                toggle={toggleDeleteCustomerModal}
              />
              {/* Active Customer Modal */}
              <ConfirmModal
                isOpen={activeCustomerModal}
                titleHeader={t("form.submit.active.customer.confirm.header")}
                titleBody={t("form.submit.active.customer.confirm.body")}
                onConfirm={activeSingleCustomerHandler}
                textBtnConfirm={t("form.submit.active.customer.confirm.agree")}
                textBtnCancel={t("form.submit.active.customer.confirm.cancel")}
                toggle={toggleActiveCustomerModal}
              />
            </Col>
            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteDataTable
                    // selectRow={selectRowCheckbox}
                    keyField="id"
                    data={customerList?.items || []}
                    columns={columnsTable}
                    page={customerParams.page}
                    sizePerPage={customerParams.sizePerPage}
                    totalSize={customerList?.totalCount || 0}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    optionShowColumnHandel={optionShowColumnHandler}
                    rowEvents={rowEventsHandler}
                    listMultipleRowAction={listMultipleRowAction}
                    listRowAction={listRowAction}
                    loading={isLoading}
                  >
                    <div className="d-flex gap-2">
                      <Link
                        to="/customer/create"
                        className="btn btn-primary btn-label"
                      >
                        <i className="fas fa-plus label-icon" />
                        {t("title.create")}
                      </Link>

                      <Button
                        color="info"
                        className="btn-label"
                        type="button"
                        onClick={() => {
                          clickAddCodeOfCustomerHandler(null);
                        }}
                        // disabled={isLoadingUpdate}
                      >
                        <i className="bx bx-plus label-icon"></i>
                        Tạo thêm mã
                      </Button>
                      <Input
                        min={1}
                        type={"number"}
                        disabled={isLoading}
                        className={`form-control`}
                        placeholder={"Nhập số lượng mã (chưa sử dụng) tối đa"}
                        style={{
                          width: "277px",
                        }}
                        onChange={handleInputChange}
                      />
                    </div>
                  </RemoteDataTable>
                  <SaleSupport
                    customerId={customerChoosen?.id}
                    isOpenSaleSupport={isViewSale}
                    toggleSaleSupport={toggleSaleSupport}
                  />
                  <CodeUseModal
                    customer={customerChoosen}
                    isOpenCodeUse={isViewCodeUse}
                    toggleCodeUse={toggleViewCodeUse}
                  />
                  <AddCodeUseModal
                    createCodeSuccessHandle={listCustomer}
                    customerDefault={customerChoosen}
                    isOpenCodeUse={isViewAddCodeUse}
                    toggleCodeUse={toggleViewAddCodeUse}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListCustomer;
